var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M7 8.595L1.595 14 0 12.405 5.405 7 0 1.595 1.595 0 7 5.405 12.405 0 14 1.595 8.595 7 14 12.405 12.405 14 7 8.595z"})),React.createElement("use",{"fill":"#9DA9B6","fillRule":"evenodd","transform":"translate(1 1)","xlinkHref":"#a","key":1})]);
}

Close.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Close;

Close.default = Close;
